import {
  Box,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Empty from '../../../components/common/Empty';
import { NumberPagination } from '../../../components/pagination/CustomPagination';
import { DetailedSearch } from '../../../components/search-input/DetailedSearchBar';
import { PrimaryButton } from '../../../components/style/ButtonStyle';
import { PrimaryBorderTable } from '../../../components/style/TableStyle';
import { CountingText, FormTitle } from '../../../components/style/TextStyle';
import { useAuthAxios } from '../../../hooks/useAuthAxios';
import { AddButtonIcon } from '../../../layouts/dashboard/nav/IconButton';
import { UserRoleListLabel, responsiveMargin } from '../../../utils/enum';
import { fDate } from '../../../utils/formatTime';
import { header } from './UserListHeader';

const PAGE_SIZE = 10;

export default function UserListPage() {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [getUsersResult, getUsers] = useAuthAxios(
    {
      method: 'GET',
      url: '/api/v1/users',
      params: {
        page: page,
        take: PAGE_SIZE,
        searchValue: search,
      },
    },
    { manual: false },
  );
  const count = _.get(getUsersResult, 'response.data.count', 0);
  const users = _.get(getUsersResult, 'response.data.result');
  // const emptyRows = PAGE_SIZE - _.get(users, 'length', 0);
  const isEmpty = _.isEmpty(users);
  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return (
    <Stack mx={responsiveMargin} spacing={5} my={10}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <FormTitle>이용자 관리 목록</FormTitle>
        <Box />
      </Stack>
      <DetailedSearch
        styleProps={{ maxWidth: '400px' }}
        placeholder="사용자 ID, 이름, 행정동, 소속과로 검색"
        onKeyDown={e => {
          if (e.key === 'Enter') {
            setSearch(e.target.value);
          }
        }}
        onClick={(e, value) => {
          setSearch(value);
        }}
      />

      <Stack
        direction="row"
        sx={{ w: '100%' }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack>
          <CountingText>총 {count}건</CountingText>
        </Stack>
        <Stack>
          <PrimaryButton
            startIcon={<AddButtonIcon />}
            onClick={() => {
              navigate(`/users/form`);
            }}
          >
            사용자 추가
          </PrimaryButton>
        </Stack>
      </Stack>
      {isEmpty ? (
        <Empty />
      ) : (
        // <PrettyScrollbarTableWrap>
        <TableContainer component={Paper} sx={{ mt: '16px !important' }}>
          <PrimaryBorderTable sx={{ minWidth: 1340 }}>
            <TableHead>
              <TableRow>
                {_.map(header, t => (
                  <TableCell align="center" key={t.id}>
                    {t?.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {_.map(users, user => (
                <TableRow
                  hover
                  role="checkbox"
                  key={user.userId}
                  onClick={() => navigate(`/users/${user.userId}`)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell align="center">{user?.id || '-'}</TableCell>
                  <TableCell align="center">{user?.name || '-'}</TableCell>
                  <TableCell align="center">
                    {user?.administrativeRegion || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {user?.departmentTitle || '-'}
                  </TableCell>
                  <TableCell align="center">{user?.phone || '-'}</TableCell>
                  <TableCell align="center">
                    {fDate(user?.createdAt, 'yyyy-MM-dd') || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {_.get(UserRoleListLabel, user?.role, '-')}
                  </TableCell>
                </TableRow>
              ))}
              {/* {_.times(emptyRows, r => (
                <TableRow key={r} style={{ height: 42 }}>
                  {_.times(header.length, t => (
                    <TableCell key={t} />
                  ))}
                </TableRow>
              ))} */}
            </TableBody>
          </PrimaryBorderTable>
        </TableContainer>
        // </PrettyScrollbarTableWrap>
      )}

      <Stack direction="row" justifyContent="center">
        <NumberPagination
          boundaryCount={1}
          count={Math.ceil(count / PAGE_SIZE)}
          siblingCount={0}
          onChange={(e, page) => {
            setPage(page);
          }}
        />
      </Stack>
    </Stack>
  );
}
